"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var defaultProps = {
  focusable: "false",
  viewBox: "0 0 1000 1000"
};

var ChevronDown = function ChevronDown(props) {
  var finalProps = {
    ...defaultProps,
    ...props,
  };
  return _react["default"].createElement("svg", finalProps, _react["default"].createElement("path", {
    d: "M968 289L514 741c-11 11-21 11-32 0L29 289c-4-5-6-11-6-16 0-13 10-23 23-23 6 0 11 2 15 7l437 436 438-436c4-5 9-7 16-7 6 0 11 2 16 7 9 10 9 21 0 32z"
  }));
};

var _default = ChevronDown;
exports["default"] = _default;
